import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import colours from 'theme/atoms/colours';

import { ReflexStep } from 'shiftNotes/_types';
import * as Styled from 'shiftNotes/styles/InstantReflex/ReflexStepCard.style';
import ReflexStepCard from './ReflexStepCard';

interface ShowProcedureCardProps {
  step: ReflexStep;
  stepNumber: number;
  totalSteps: number;
  label?: string;
}

export default function ShowProcedureCard({
  step,
  stepNumber,
  totalSteps,
  label,
}: ShowProcedureCardProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');
  const hasBody = (step.body ?? '').trim().length > 0;

  return (
    <ReflexStepCard
      label={
        label ??
        (totalSteps === 1
          ? t('instantReflex.todoLabel')
          : t('instantReflex.stepLabel', { n: stepNumber }))
      }
      labelColor={colours.blue[500]}
      icon={<General.CheckCircle />}
      title={step.title}
    >
      {hasBody && <Styled.Body>{step.body}</Styled.Body>}
    </ReflexStepCard>
  );
}
